import { configureStore } from "@reduxjs/toolkit";
import organizationsReducer from "./features/organizationsSlice";
import usersReducer from "./features/usersSlice";
import adminEventsReducer from "./features/adminEventsSlice";
import showsAndRoomsSlice from "./features/showsAndRoomsSlice";
import performersReducer from "./features/performersSlice";
import crmReducer from "./features/crmSlice";
import attendeesReducer from "./features/attendeesSlice";
import trackingPixelsReducer from "./features/trackingPixelsSlice";
const store = configureStore({
  reducer: {
    adminEvents: adminEventsReducer,
    users: usersReducer,
    organizations: organizationsReducer,
    showsAndRooms: showsAndRoomsSlice,
    performers: performersReducer,
    crm: crmReducer,
    attendees: attendeesReducer,
    trackingPixels: trackingPixelsReducer,
  },
});

export default store;
